var _rect, _g, _g2, _path, _g3, _path2, _rect2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResServiceKakaoNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 80,
    viewBox: "0 0 102 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 13,
    width: 32,
    height: 54,
    rx: 4,
    fill: "white",
    stroke: "#2E2E30",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_566_59438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 38,
    r: 16,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_566_59438)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 38,
    r: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0003 28.2239C23.6027 28.2239 19.2256 32.2479 19.2256 37.2101C19.2256 40.8752 20.7705 42.6264 22.8853 44.2205C22.886 44.2211 22.8867 44.2215 22.8875 44.2219C22.8923 44.2243 22.8953 44.2292 22.8953 44.2346V48.5275C22.8953 48.7312 23.1296 48.8477 23.2918 48.7245L26.9381 46.032C26.975 46.0048 27.0235 45.9988 27.0659 46.0164C27.0744 46.0199 27.0833 46.0225 27.0923 46.0242C27.7098 46.1368 28.3473 46.1964 29.0003 46.1964C34.3979 46.1964 38.775 42.1724 38.775 37.2079C38.775 32.2434 34.4002 28.2239 29.0003 28.2239Z",
    fill: "#D5D4FF",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_566_59438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.02 33.6098C26.0367 34.34 26 40.9348 26 41.4203C26 42.192 27.7429 42.1882 27.7396 41.4203C27.7396 40.5245 27.7396 38.8269 27.7396 38.8269L28.2504 38.3639L30.4875 41.8043C30.9382 42.478 32.3606 41.2622 31.9099 40.5885L29.5359 37.0615C29.5359 37.0615 31.1486 35.0966 31.783 34.3852C32.1536 33.9711 31.005 32.665 30.6344 33.0828C30.2738 33.4856 27.7496 36.335 27.7496 36.335C27.7496 36.335 27.773 34.5471 27.7496 33.5571C27.7396 33.1807 27.3322 33 26.9149 33C26.4674 33 26.01 33.207 26.02 33.6098Z",
    fill: "#2E2E30"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.792 40.0417C45.792 40.2853 45.8085 40.5281 45.8416 40.7701C45.8748 41.0121 45.9314 41.2506 46.0115 41.4857C46.0649 41.663 46.0593 41.8326 45.9947 41.9945C45.93 42.1563 45.8203 42.2725 45.6654 42.343C45.5019 42.4221 45.3392 42.4285 45.1774 42.3622C45.0155 42.296 44.9079 42.1742 44.8545 41.9969C44.7434 41.6828 44.6635 41.3604 44.6149 41.0297C44.5663 40.699 44.542 40.3697 44.542 40.0417C44.542 38.2394 45.1691 36.7055 46.4234 35.44C47.6777 34.1745 49.2033 33.5418 51.0003 33.5418H51.651L50.5484 32.4392C50.433 32.3238 50.374 32.1788 50.3713 32.0041C50.3686 31.8294 50.4277 31.6817 50.5484 31.561C50.6691 31.4403 50.8155 31.3799 50.9875 31.3799C51.1595 31.3799 51.3059 31.4403 51.4266 31.561L53.5051 33.6395C53.6557 33.7901 53.7311 33.9659 53.7311 34.1667C53.7311 34.3676 53.6557 34.5433 53.5051 34.694L51.4266 36.7725C51.3112 36.8879 51.1662 36.9469 50.9915 36.9496C50.8168 36.9523 50.6691 36.8932 50.5484 36.7725C50.4277 36.6518 50.3673 36.5054 50.3673 36.3334C50.3673 36.1614 50.4277 36.015 50.5484 35.8943L51.651 34.7917H51.0003C49.5527 34.7917 48.3227 35.3013 47.3104 36.3206C46.2981 37.3398 45.792 38.5802 45.792 40.0417ZM56.2087 39.9584C56.2087 39.7148 56.1921 39.472 56.159 39.23C56.1258 38.988 56.0692 38.7495 55.9891 38.5145C55.9357 38.3371 55.9413 38.1675 56.0059 38.0057C56.0706 37.8438 56.1803 37.7276 56.3352 37.6571C56.4987 37.5781 56.66 37.5717 56.8192 37.6379C56.9784 37.7041 57.0847 37.8259 57.1381 38.0033C57.2492 38.3174 57.3304 38.6398 57.3817 38.9704C57.433 39.3011 57.4586 39.6304 57.4586 39.9584C57.4586 41.7607 56.8315 43.2947 55.5772 44.5602C54.3229 45.8256 52.7973 46.4584 51.0003 46.4584H50.3496L51.4522 47.561C51.5676 47.6764 51.6266 47.8214 51.6293 47.9961C51.632 48.1707 51.5729 48.3184 51.4522 48.4392C51.3315 48.5599 51.1851 48.6203 51.0131 48.6203C50.8411 48.6203 50.6948 48.5599 50.574 48.4392L48.4955 46.3607C48.3449 46.21 48.2696 46.0342 48.2696 45.8334C48.2696 45.6326 48.3449 45.4568 48.4955 45.3062L50.574 43.2277C50.6894 43.1123 50.8344 43.0532 51.0091 43.0506C51.1838 43.0479 51.3315 43.1069 51.4522 43.2277C51.5729 43.3484 51.6333 43.4947 51.6333 43.6667C51.6333 43.8387 51.5729 43.9851 51.4522 44.1058L50.3496 45.2084H51.0003C52.448 45.2084 53.6779 44.6988 54.6902 43.6796C55.7025 42.6603 56.2087 41.4199 56.2087 39.9584Z",
    fill: "#2E2E30",
    stroke: "#2E2E30",
    strokeWidth: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.72,
    y: 30.22,
    width: 18.56,
    height: 16.56,
    rx: 2.28,
    fill: "white",
    stroke: "#2E2E30",
    strokeWidth: 1.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.72 32.5C63.72 31.2408 64.7408 30.22 66 30.22H80C81.2592 30.22 82.28 31.2408 82.28 32.5V34.78H63.72V32.5Z",
    fill: "#D5D5FF",
    stroke: "#2E2E30",
    strokeWidth: 1.44
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0762 29V31.5",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9229 29V31.5",
    stroke: "#2E2E30",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 37V44H71.9375V40.4978L74.0586 44H76.5V37H74.0586V40.4978L71.9375 37H69.5Z",
    fill: "#2E2E30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_566_59438",
    x: 44,
    y: 9,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_566_59438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_566_59438",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_566_59438",
    x: 9.53674e-7,
    y: 9,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0 0.784314 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_566_59438"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_566_59438",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_566_59438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9,
    fill: "white",
    transform: "translate(26 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResServiceKakaoNaver);
export default __webpack_public_path__ + "static/media/ic_res_service_kakao_naver.705e53d4ee5bd7cb6439666e3a1e272d.svg";
export { ForwardRef as ReactComponent };